import { makeStyles } from '@material-ui/core';

export const getProposalPreviewDefaultEnergyProductionCaptionStyles =
  makeStyles((theme) => ({
    root: {
      color: theme.palette.text.secondary,
    },
  }));
